/*
 * @Author: JEAN
 * @LastEditors: shaweiwei 623243397@qq.com
 * @Description: 购买弹框
 * @Date: 2022-08-17 13:39:49
 * @LastEditTime: 2023-02-01 09:48:45
 */
// 状态管理方法
import { observable, action, flow, computed } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import { initConfig } from 'utils/wxUtils';
import { shareFriend, sharePyq } from 'utils/wxShare';
import { get } from 'lodash';
import Stores from 'config/Stores';
import { activityTypeMap, advanceSaleStatusMap, contentTipPosTypeMap } from 'utils/constants';

// 引入Serv
import Serv from './BuyModalServ';
import { Toast } from 'antd-mobile';

class buyModalMod {
  // 剩余三生豆
  @observable beanNumber = 0;

  // 剩余虚拟产品
  @observable virProduct = {};

  // 优惠券信息
  @observable couponInfo = {
    usableCount: [],
    usableList: [],
    unUsableCount: [],
    unUsableList: []
  };

  // 优惠券集合
  couponList = [];

  // 已选的优惠券列表（在couponInfo.usableList列表的index索引）
  @observable selectedCoupons = [];

  @observable discountSalePrice = 0;

  @observable activityId = '';

  @observable orderInfo = {
    freightAmount: 0,
    itemNumber: 0,
    activityDiscountAmount: 0,
    orderBv: 0,
    totalAmount: 0,
    couponsAmount: 1
  };

  // 商品信息
  @observable items = [];

  toastNum = 0;

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 支付金额
   */
  @computed
  get realPayAmount() {
    const {
      totalAmount,
      activityDiscountAmount = 0,
      depositAmount = 0,
      cheapAmount,
      tailAmount = 0
    } = this.orderInfo;
    const { productList } = this;
    // 商品原价总和
    let originTotal = [0, ...productList].reduce((pre, next) => pre + next.totalDiscountAmount);

    if (this.activityType == activityTypeMap.advanceSale) {
      if (this.advanceSaleStatus == advanceSaleStatusMap.PAYFORDEPOSIT) {
        return depositAmount;
      } else {
        originTotal = tailAmount;
      }
    } else if (this.activityType == activityTypeMap.groupBuy) {
      originTotal = (totalAmount * 100 - activityDiscountAmount * 100) / 100;
    }
    // 商品优惠之后价格总和
    let realAmount = (originTotal * 100 - this.couponDiscount * 100) / 100;
    const hasIncPrice = (get(this.orderInfo, 'cheapItemList') || []).length > 0;
    // 有加价购时，加上加价购金额
    let payAmount = !hasIncPrice ? realAmount : (realAmount + (cheapAmount || 0)).toFixed(2);

    payAmount = payAmount < 0 ? 0 : payAmount * 1;
    return payAmount.toFixed(2);
  }

  /**
   * 获取下单可用优惠券
   */
  getCouponList = flow(function* () {
    const params = {
      items: this.items,
      orderType: 1,
      orderProperty: 1,
      discount: '', //
      learnOrderTag: 1
    };
    // Toast.loading();
    const { data } = yield Serv.getCouponList(params);
    const { usableCount, usableList, unUsableCount, unUsableList } = data || {};
    this.couponInfo = {
      usableCount,
      usableList,
      unUsableCount,
      unUsableList
    };
    // Toast.hide();
  });

  @computed
  get productList() {
    let newBv = 0;
    let list = this.items.map((item) => ({
      ...item,
      realMoney: item.totalDiscountAmount,
      realBv: newBv != 0 ? newBv : Math.floor(item.totalDiscountBv / item.itemNum) * item.itemNum
    }));
    // 循环每种类型优惠券
    const newSelectedCoupons =
      this.selectedCoupons.length > 0 &&
      this.couponInfo.usableList &&
      this.couponInfo.usableList.length > 0
        ? this.selectedCoupons.sort((a, b) => {
            return (
              this.couponInfo.usableList[a] &&
              this.couponInfo.usableList[a]['bvCalculateType'] - this.couponInfo.usableList[b] &&
              this.couponInfo.usableList[b]['bvCalculateType']
            );
          })
        : [];
    newSelectedCoupons.forEach((couponIndex) => {
      const coupon = this.couponInfo.usableList[couponIndex] || {};
      let totalAmount = 0;
      const { bvCalculateType, couponType, itemRange, itemIdList } = coupon || {};
      // 抵扣券，计算该商品所占“优惠券涉及商品范围内总金额”的比重
      if (couponType == 1) {
        list.forEach((product) => {
          if (itemRange == 1 || (itemIdList && itemIdList.includes(product.itemSerial))) {
            totalAmount += product.realMoney;
          }
        });
      }
      list.forEach((product) => {
        // 如果该优惠券对该商品有优惠，则计算
        if (itemRange == 1 || (itemIdList && itemIdList.includes(product.itemSerial))) {
          // 抵扣券，直接按比例减去金额和bv即可
          if (couponType == 1) {
            const preRealMoney = product.realMoney;
            // 需要判断分母totalAmount为0的情况
            product.realMoney -=
              totalAmount == 0
                ? (coupon.couponValue * 100) / 100
                : ((product.realMoney / totalAmount) * coupon.couponValue * 100) / 100;

            if (bvCalculateType === 2) {
              // bv不变优惠券 则不处理BV显示
            } else {
              // 需要判断分母preRealMoney为0的情况
              product.realBv =
                preRealMoney == 0
                  ? 0
                  : Math.round(((product.realBv * product.realMoney) / preRealMoney) * 100) / 100;
            }
            // bv全减逻辑添加
            if (bvCalculateType === 0) {
              product.realBv = 0;
            }
          }
          // 折扣券，couponValue是抵扣折扣，需要100来减才是实际打折
          if (couponType == 2) {
            product.realMoney = (product.realMoney * coupon.couponValue) / 100;
            if (bvCalculateType === 2) {
              // BV 暂时不做处理
            } else {
              product.realBv = (product.realBv * coupon.couponValue) / 100;
            }
            // bv全减逻辑添加
            if (bvCalculateType === 0) {
              product.realBv = 0;
            }
          }
          if (couponType == 5) {
            product.realMoney = 0;
            product.realBv = 0;
          }
          // 每件商品最多只能减到0元
          if (product.realMoney < 0) product.realMoney = 0;
          if (product.realBv < 0) product.realBv = 0;
        }
      });
    });
    return list;
  }

  // 选择优惠券
  @action
  switchCoupon(index) {
    const freightAmount = 0;
    let list = [...this.selectedCoupons];
    let coupon = this.couponInfo.usableList[index];
    if (list.length && !list.includes(index)) {
      let oldCoupon = this.couponInfo.usableList[list[0]];
      // 0门槛 + 券开启了允许叠加 + 同类型的券才可以叠加使用
      let noAllow = oldCoupon.thresholdAmount != 0 || oldCoupon.useSuperimposedType != 1;
      noAllow =
        noAllow ||
        !(
          coupon.thresholdAmount == 0 &&
          coupon.useSuperimposedType == 1 &&
          coupon.couponType == oldCoupon.couponType
        );
      if (noAllow) {
        Toast.info('已选优惠券不可和该优惠券叠加使用');
        return;
      }
    }
    if (!list.includes(index)) {
      // 总金额减到0了，就不允许继续多选券
      if (this.payAmount - freightAmount <= 0) {
        Toast.info('当前订单已达该券使用上限，不可再使用');
        return;
      }
      // 该券是指定产品券，若指定的所有商品都已经把金额减到0了，就不允许选择该券
      if (coupon.itemRange != 1) {
        for (let item of coupon.itemIdList) {
          let product = this.productList.find((product) => product.itemSerial == item);
          if (product && Math.round(product.realMoney * 100) / 100 != 0) break;
          else if (product) {
            Toast.info('当前订单已达该券使用上限，不可再使用');
            return;
          }
        }
      }
      list.push(index);
    } else {
      list.splice(list.indexOf(index), 1);
    }
    this.selectedCoupons = list;
  }

  @computed
  get couponDiscount() {
    const total = [0, ...this.productList].reduce(
      (pre, next) => pre + next.totalDiscountAmount - next.realMoney
    );
    return Math.round(total * 100) / 100;
  }

  /**
   *  获取课程详情关联的虚拟商品信息
   */
  getVirProduct = flow(function* (code) {
    try {
      const { data } = yield Serv.getVirProduct(code);
      this.virProduct = data;
      // this.getConfirmTip(data.id);
      return data;
    } catch (e) {}
  });

  /**
   * 获取订单提醒
   */
  getConfirmTip = flow(function* (id) {
    const params = {
      posType: contentTipPosTypeMap.CONFIRMORDER2,
      areaCode: '340803000000',
      product: id
    };
    try {
      const { data } = yield Serv.getConfirmTip(params);
      if (data) {
        let list = data;
        // 过滤专题页提示
        list = list
          .filter((item) => item.cueType !== 3)
          .sort((a, b) => {
            // console.log(a, b);
            if (b.priority - a.priority === 0) {
              return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
            } else {
              return b.priority - a.priority;
            }

            // if (a.priority > b.priority) {
            //   return 1;
            // } else {
            //   return -1;
            // }
          });
        this.confirmTip = list;
      }
    } catch (err) {}
  });

  /**
   * 获取云豆数量
   *
   * @memberof CourseMod
   */
  getBeanNumber = flow(function* () {
    try {
      const { data } = yield Serv.getBeanNumber();
      const { beanNum = 0 } = data;
      this.beanNumber = beanNum || 0;
      return data;
    } catch (e) {}
  });

  /**
   * 云豆兑换商学院资源
   */
  exchangeCourseByBean = flow(function* (params) {
    const { token } = Stores.AppMod;
    if (!token) {
      window.app.routerGoTo('/login');
      return;
    }
    try {
      Toast.loading();
      const { resultMsg, data, resultCode } = yield Serv.exchangeCourseByBean(params);
      if (resultCode == 401) {
        window.app.routerGoTo('/login');
        return;
      }
      return +resultCode === 0;
    } catch (error) {
      const { resultCode } = error || {};
      if (resultCode == 401) {
        window.app.routerGoTo('/login');
        return;
      }
      Toast.hide();
    }
  });

  /**
   * 立即购买
   *
   * @memberof CourseView
   */
  confirmBuy = async (sign, isActivity) => {
    const { userInfo, isPlus } = Stores.AppMod;
    const url = isActivity ? 'biz/tradecore/trade/promotion/add' : 'biz/tradecore/trade/add';
    const deliveryAddress = {
      address: 'cscscscscscs',
      areaCode: '340803000000',
      areaName: '大观区',
      cityCode: '340800000000',
      cityName: '安庆市',
      defaultAddress: true,
      deliveryAddressMap: null,
      deliveryMobile: '18500000001',
      deliveryName: 'cscs',
      deliveryType: '1',
      detailed: '安徽省安庆市大观区cscscscscscs',
      extFields: {},
      geoX: null,
      geoY: null,
      provinceCode: '340000000000',
      provinceName: '安徽省',
      shopCode: null,
      streetCode: '',
      streetName: '',
      userAddressId: '1311114523407022177',
      userAddressList: null
    };
    const { userType, shopNo, shopCode } = userInfo || {};
    const orderSources = {
      1: 'CUSTOMER',
      2: 'MEMBER',
      3: 'SHOP',
      5: 'SHOP'
    };
    const { bv, code, price, plusPrice, id, name, status, questionStatus, skuId, versionId, type } =
      this.virProduct || {};
    const thePrice = sign && !!isPlus ? plusPrice : price;
    const itemsValue = this.items;
    itemsValue[0].activityIdList = this.activityId ? [this.activityId] : [];
    itemsValue[0].groupKey = parseInt(Math.random() * 1001, 10) + '';
    const params = {
      deliveryAddress,
      shopCode: shopCode || shopNo,
      orderItems: itemsValue,
      // orderItems: [{
      //   bv,
      //   code,
      //   discountBv: bv,
      //   discountPrice: thePrice,
      //   itemName: name,
      //   itemNum: 1,
      //   itemPrice: thePrice,
      //   itemSerial: id,
      //   itemStatus: status,
      //   itemType: type,
      //   retailBv: 0,
      //   retailPrice: 0,
      //   skuSerial: skuId,
      //   totalAmount: thePrice,
      //   totalBV: bv,
      //   totalDiscountAmount: thePrice,
      //   totalDiscountBv: bv,
      //   versionId,
      //   groupKey: 0,
      // }],
      // 订单类型 '1'零售订单 '2'复消订单 '3'自主开卡 '4'会员自主升级 '5'会员新客注册 '6'申请开店 '7'店铺新客注册 '8'店铺老客升级。 '9': 维多益体系会员代客升级
      orderType: 1,
      orderProperty: 1, // 配送比例
      payAmount: this.realPayAmount,
      orderBv: bv,
      shopCart: 0, // 是否购物车下单,0不是，1是
      totalAmount: this.realPayAmount,
      totalItemNum: 1,
      dgMemberCode: '',
      dgMemberName: '',
      bizGiveawayReqDto: {},
      couponList: [],
      freightCouponList: [],
      learnOrderTag: 1,
      deliveryType: 1,
      orderSource: orderSources[`${userType}`],
      couponList: this.selectedCoupons.map((item) => this.couponInfo.usableList[item].id)
    };
    isActivity && (params.businessSchoolTag = 1);
    const result = await this.buyCourse(params, url);
    if (result) {
      return result;
    }
  };

  /**
   * 计算价格
   *
   * @memberof CourseView
   */
  confirmPrice = flow(function* ({ displayName, skuId, id, price, plusPrice, sign, activityId }) {
    const { userInfo, isPlus } = Stores.AppMod;
    const thePrice = sign && !!isPlus ? plusPrice : price;
    try {
      const itemsObj = {
        itemName: displayName,
        itemNum: 1,
        itemPrice: thePrice,
        itemSerial: id,
        skuSerial: skuId,
        groupKey: parseInt(Math.random() * 1001, 10) + ''
      };
      this.activityId && (itemsObj.activityIdList = [this.activityId]);
      const params = {
        items: [itemsObj],
        learnOrderTag: 1,
        orderType: 1,
        tradeNo: '',
        orderProperty: 1,
        dgMemberCode: '',
        dgMemberName: '',
        bizGiveawayReqDto: {
          freeItem: [],
          giftList: [],
          cheapItem: []
        }
      };
      const { data, resultCode, resultMsg } = yield Serv.confirmPrice(params);
      if (+resultCode === 0) {
        const { items, totalAmount, tailAmount, orderBv, activityDiscountAmount } = data || {};
        this.items = items;
        this.orderInfo.totalAmount = totalAmount;
        this.orderInfo.tailAmount = tailAmount;
        this.orderInfo.orderBv = orderBv;
        this.orderInfo.activityDiscountAmount = activityDiscountAmount;
      } else {
        if (this.toastNum % 2 === 0) {
          Toast.info(resultMsg);
        }
        this.toastNum = this.toastNum + 1;
      }
      return resultCode;
    } catch (error) {
      console.log(error, 'errorrr');
    }
  });

  /**
   *购买课程
   *
   * @memberof CourseMod
   */
  buyCourse = flow(function* (params, url) {
    try {
      Toast.loading('请稍候', 100);
      const { data, resultCode, resultMsg, tk } = yield Serv.buyCourse(params, url);
      Toast.hide();
      if (tk) {
        return tk;
      } else {
        if (resultCode == 0) {
          const { tradeNo } = data;
          Util.setLocalCache(Config.localStorageKeys.course_buy, 1);
          // window.app.routerGoTo(`/shop/payMent/${tradeNo}`);
          window.app.routerGoTo(`/shop/payMent/${tradeNo}?isVirtual=${true}`);
        } else {
          Toast.info(resultMsg);
        }
      }
    } catch (e) {}
  });
}
const BuyModalMod = new buyModalMod();

export default BuyModalMod;



// WEBPACK FOOTER //
// ./src/pages/Learn/component/BuyMadol/BuyModalMod.js